module.exports = __webpack_public_path__ + "static/media/Biotil.20ffb758.svg";